import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import request from '../api';
import { miloAlert } from '../AlertDialog';
import { bindArea } from '../AreaBind/areabind';
import { selectRole } from '../RoleSelector/roleselector';
import { selectRoleMobile } from '../RoleSelectorMobile/roleselectormobile';
import { Customize as CustomizeSdk } from '@tencent/milo-core';
var customize = CustomizeSdk.submit.bind(CustomizeSdk);

var CustomizeComp = /*#__PURE__*/function () {
  function CustomizeComp(option) {
    _classCallCheck(this, CustomizeComp);

    this.option = _objectSpread({
      plat: 'pc',
      iActivityId: '',
      iFlowId: '',
      sData: {},
      onSuccess: null,
      onFail: null,
      extendRole: {}
    }, option);
  }

  _createClass(CustomizeComp, [{
    key: "submit",
    value: function submit() {
      var self = this;
      var _self$option = self.option,
          onSuccess = _self$option.onSuccess,
          onFail = _self$option.onFail,
          plat = _self$option.plat;
      return request(customize, self.option).then(function (res) {
        if (onSuccess) {
          onSuccess(res);
        }
      })["catch"](function (err) {
        if (err.errCode && parseInt(err.errCode) === -1) {
          // 登陆错误统一处理
          return;
        }

        if (err.errCode === 2) {
          // 需要角色，从绑定大区获取
          bindArea({
            bindOptions: _objectSpread(_objectSpread({}, err.areaBindOption), {}, {
              flowConfig: _objectSpread({}, self.option.extendRole),
              onSuccess: function onSuccess() {
                self.submit();
              }
            })
          });
        } else if (err.errCode === 3) {
          // 需要角色，从角色选择器获取
          var selectRoleFn = plat === 'mobile' ? selectRoleMobile : selectRole;

          var rsOption = _objectSpread(_objectSpread(_objectSpread({}, err.rsOption), self.option.extendRole), {}, {
            onSubmit: function onSubmit(role) {
              var sData = self.option.flowConfig.sData || {};
              sData = _objectSpread(_objectSpread({}, sData), {}, {
                sServiceType: err.rsOption.gameId,
                sArea: role.area,
                sPartition: role.partition,
                sRoleId: role.roleId,
                sAreaName: role.areaName,
                sRoleName: role.roleName,
                md5str: role.md5str,
                iSex: role.roleSex || '',
                sPlatId: role.platid,
                ams_checkparam: role.checkparam,
                checkparam: role.checkparam
              });
              self.option.flowConfig.sData = sData;
              self.submit();
            }
          });

          selectRoleFn(rsOption);
        } else if (err.errCode == -1) {} else {
          if (onFail) {
            onFail(err);
          } else {
            var errMsg = err.errMsg || err.msg || err.sMsg;
            miloAlert(errMsg);
          }
        }
      });
    }
  }]);

  return CustomizeComp;
}();

export { CustomizeComp as default };
export var Customize = {
  submit: function submit(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new CustomizeComp(option);
        return instance.submit();
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '自定义模块初始化失败'
        });
      }
    });
  }
};